'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mergeEdges = exports.getEdges = undefined;

var _rect = require('./rect');

var rectLib = _interopRequireWildcard(_rect);

var _line = require('./line');

var lineLib = _interopRequireWildcard(_line);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// √
var getEdges = exports.getEdges = function getEdges(rect1) {
    return ['left', 'right', 'top', 'bottom'].reduce(function (obj, prop) {
        obj[prop] = rectLib.getLineFromRect(rect1, prop);
        return obj;
    }, {});
};

// √
var mergeEdges = exports.mergeEdges = function mergeEdges(edges1, edges2) {
    return {
        left: lineLib.getNewLine(edges1.left, edges2.left, lineLib.lineComparison.leftmost),
        right: lineLib.getNewLine(edges1.right, edges2.right, lineLib.lineComparison.rightmost),
        top: lineLib.getNewLine(edges1.top, edges2.top, lineLib.lineComparison.upper),
        bottom: lineLib.getNewLine(edges1.bottom, edges2.bottom, lineLib.lineComparison.lower)
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/common/documentOrder/geometry/edges.js
// module id = 2261
// module chunks = 0